import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Spin } from "antd";
import { useAuthContext } from "../context/AuthContext";

/**
 * Erlaubt nur Nutzer mit Rolle "administrator". Sonst Redirect auf /auftrag.
 */
const AdministratorRoute = () => {
  const { user, isLoading } = useAuthContext();

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: 48,
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!user || user.role?.type !== "administrator") {
    return <Navigate to="/auftrag" replace />;
  }

  return <Outlet />;
};

export default AdministratorRoute;
